module.exports = __webpack_public_path__ + "static/img/3_2.febdb389.jpg";